<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormAutorizarSalidaExtra" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label class="form-label" for="ResponsableRecibe">Personal que Recibe</label>
                            <div class="input-group">
                                <input type="text" v-model="ObjSalidas.NombreResponsableRecibe" class="form-control" id="ResponsableRecibe" placeholder="Ingresar Recibe" readonly />
                                <button type="button" @click="AbrirModalPersonal()" class="btn btn-outline-primary boder-extend" id="button-addon1">
                                    <i class="fa fa-search"></i>
                                </button>
                            </div>
                            <!-- <CValidation v-if="this.errorvalidacion.IdCliente" :Mensaje="'*'+errorvalidacion.IdCliente[0]"/> -->
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <nav>
                                <div class="nav nav-tabs" id="nav-tab2" role="tablist">
                                    <!-- <button type="button" class="nav-link active" id="nav-elementos-tab" data-bs-toggle="tab" data-bs-target="#nav-elementos" role="tab" aria-controls="nav-elementos" aria-selected="false">
                                        Elementos del Evento
                                    </button> -->
                                    <button type="button" class="nav-link active" id="nav-herramientas-tab" data-bs-toggle="tab" data-bs-target="#nav-herramientas" role="tab" aria-controls="nav-herramientas" aria-selected="false">
                                        Herramientas
                                    </button>
                                    <button type="button" class="nav-link" id="nav-insumos-tab" data-bs-toggle="tab" data-bs-target="#nav-insumos" role="tab" aria-controls="nav-insumos" aria-selected="false">
                                        Insumos
                                    </button>
                                </div>
                            </nav>

                            <div class="tab-content" id="nav-tabContent">
                                <div v-if="false" class="tab-pane fade show active pt-3" id="nav-elementos" role="tabpanel" aria-labelledby="nav-elementos-tab">
                                    <div class="table-responsive" v-for="(Arreglo,key,ind) in ObjSalidas.ElementosGaleria" :key="ind">
                                        <h5>{{ 'Evento '+Arreglo[0].cotizacion_evento.Evento }}</h5>
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Cantidad de Salida</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item,index) in Arreglo" :key="index">
                                                    <td style="width:55%">{{ item.Nombre }}</td>
                                                    <td>{{ item.CantidadSalida }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="tab-pane fade show active" id="nav-herramientas" role="tabpanel" aria-labelledby="nav-herramientas-tab">
                                    <div class="table-responsive">
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Seleccionar</th>
                                                    <th>Nombre</th>
                                                    <th>Cantidad de Salida</th>
                                                    <th>Observaciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item,index) in ObjSalidas.Herramientas" :key="index">
                                                    <td class="text-center">
                                                        <div class="form-check">
                                                            <input type="checkbox" v-model="item.Check" @change="SeleccionConcepto(item)" :id="'chkh'+index" class="form-check-input">
                                                            <label class="form-check-label" :for="'chkh'+index">
                                                            </label>
                                                        </div>    
                                                    </td>
                                                    <td style="width:55%">{{ item.Nombre }}</td>
                                                    <td>{{ item.CantidadSalida }}</td>
                                                    <td><textarea name="" id="" cols="30" rows="3" v-model="item.ComentarioSalida" class="form-control"></textarea></td>    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="tab-pane fade show" id="nav-insumos" role="tabpanel" aria-labelledby="nav-insumos-tab">
                                    <div class="table-responsive">
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Seleccionar</th>
                                                    <th>Nombre</th>
                                                    <th>Cantidad de Salida</th>
                                                    <th>Observaciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item,index) in ObjSalidas.Insumos" :key="index">
                                                    <td class="text-center">
                                                        <div class="form-check">
                                                            <input type="checkbox" v-model="item.Check" @change="SeleccionConcepto(item)" :id="'chkI'+index" class="form-check-input">
                                                            <label class="form-check-label" :for="'chkI'+index">
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td style="width:55%">{{ item.Nombre }}</td>
                                                    <!-- <td><input :disabled="!item.Check" type="text" class="form-control" v-model="item.CantidadSalida"></td> -->
                                                    <td>{{ item.CantidadSalida }}</td>
                                                    <td><textarea name="" id="" cols="30" rows="3" v-model="item.ComentarioSalida" class="form-control"></textarea></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                        </div>
                        <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                            <label for="TipoGuardado">Forma de Guardar:</label>
                            <select v-model="TipoGuardado" id="TipoGuardado" class="form-select">
                                <option value="Temporal">Temporal</option>
                                <option value="Definitivo">Definitivo</option>
                            </select>
                        </div>
                    </div>
                </form>
                <CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
                    <template slot="Form">
                        <ListUsuarios :poBtnSave="oBtnSave2"></ListUsuarios>
                    </template>
                </CModal>

            </div>
        </template>
    </CLoader>
</template>

<script>

import ListUsuarios from '@/views/modulos/almacen/solicitudSalida/ListUsuarios.vue';
const EmitEjecuta2 = 'seccionPersonalSalida';

export default {
    name:'AutorizarSalidas',
    props:['poBtnSave'],
    components:{
        ListUsuarios,
    },
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            ConfigModal2:{
                ModalTitle: "Personal",
                ModalNameId: 'ModalForm3',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'lg',
				ShowFooter: false,
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            ObjSalidas:{
                ElementosGaleria:[],
                Herramientas:[],
                Insumos:[],
                ResponsableRecibe: 0,
                NombreResponsableRecibe: '',
            },
            ObjEvento:{},
            ObjSolicitudSalidaExtra:{},
            Emit: this.poBtnSave.EmitSeccion,
            errorvalidacion: [],
            TipoGuardado: 'Temporal'
        }
    },
    methods: {
        async Guardar(){
            let BndError = false;
            let Mensaje = "";

            if (this.ObjSalidas.ResponsableRecibe == 0) {
				Mensaje = 'Debe Seleccionar Al Personal que recibe';
                BndError = true;
			}

            if (BndError) {
				this.poBtnSave.DisableBtn = false;
                this.$toast.warning(Mensaje);
                return false;
            }

            this.poBtnSave.DisableBtn = true;

            let ElementosGaleria=[];
            /* for (const [Index,Elementos] of Object.entries(this.ObjSalidas.ElementosGaleria)) {
                Elementos.forEach(Elemento => {
                    ElementosGaleria.push(Elemento);
                });
            } */

            let formData=new FormData();
            formData.set("ElementosGaleria",JSON.stringify(ElementosGaleria));
            formData.set("Herramientas",JSON.stringify(this.ObjSalidas.Herramientas));
            formData.set("Insumos",JSON.stringify(this.ObjSalidas.Insumos));
            formData.set("IdUserRecibe",this.ObjSalidas.IdUserRecibe);
            formData.set("Estatus",'Autorizada');
            formData.set('TipoGuardado',this.TipoGuardado);

            await this.$http.post('solicitudesAlmacenAutorizar2/'+this.ObjSolicitudSalidaExtra.IdSolicitudSalidaExtra,formData
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionSolicitudAlmacen');
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar()
        {
            this.$http.get('marcarSalidaAlmacenExtra',{
                params:{
                    IdCotizacion: this.ObjSolicitudSalidaExtra.IdCotizacion,
                    IdMovimientoAlmacen: this.ObjSolicitudSalidaExtra.salida_extra.IdSalidaExtra
                }
            }).then((res)=>{
                
                this.ObjSalidas.Herramientas = res.data.data.Herramientas;
                this.ObjSalidas.Insumos = res.data.data.Insumos;
                this.ConfigLoad.ShowLoader = false;
            })
        },
        AbrirModalPersonal()
		{
			this.bus.$emit('NewModal_'+EmitEjecuta2,this.ObjSalidas.ResponsableRecibe);
		},
        SetDataPersonal(obj)
        {
			this.ObjSalidas.IdUserRecibe = obj.ResponsableRecibe;
			this.ObjSalidas.NombreResponsableRecibe = obj.NombreResponsableRecibe;
		},
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id,Obj)=>{
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
            console.log(Obj)
            this.ObjSolicitudSalidaExtra = Obj;

            this.Recuperar();
            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>{
                this.Guardar();
            });
        });

        this.bus.$off('AgregarPersonal');
        this.bus.$on('AgregarPersonal',(obj)=>
        {
            this.SetDataPersonal(obj);
        });
    },
}
</script>

<style>

</style>